import { Flex, FlexItem, MultiSelect, Text } from '@bigcommerce/big-design';
import { DeleteIcon } from '@bigcommerce/big-design-icons';
import { createSelectOptions } from '../../../../utils';
import { CenteredText } from './StyledComponents';

const TAGS = [
	'Prefactory Followup',
	'Factory Followup',
	'Followup Resolved',
	'Customer Service New',
	'Customer Service Pending',
	'Customer Service Resolved',
	'Hold Order',
	'Hold Order Resolved',
	'Request to Cancel',
	'Verified',
	'Exported',
	'In Review',
];
const CHILD_TAGS = [
	'Order Cancellation (Sent to Vendor)',
	'Order Changes (Sent to Vendor)',
	'Order Status Request',
	'Warranty',
	'Installation',
	'Fit',
	'Quality',
	'Email for Pictures',
	'Awaiting Pictures',
	'Pictures Received',
	'Request Opened with Vendor',
	'Ongoing Requests with Vendor',
	'Additional Information Required – from Vendor',
	'Additional Information Required – from Customer',
	'Replacement – Pending Replacement',
	'Replacement  OrderSummarySection Required',
	'Replacement – No OrderSummarySection Required',
	'Replacement  Confirmed',
	'Return  Authorization Required',
	'Return – Label Required',
	'Return Authorized',
	'Return – Sent Back',
	'Return – Delivered to Vendor',
	'Return – Reorder Required',
	'Exchange  Authorization Required',
	'Exchange – Label Required',
	'Exchange  Authorized',
	'Exchange – Sent Back',
	'Unauthorized Return',
	'Return – Delivered to Vendor',
	'Return – Refund Request',
	'Discount Request',
	'Tracking – Shipped to Incorrect Address',
	'Tracking – Lost Package',
];
export const TAG_OPTIONS = createSelectOptions(TAGS, false);
export const CHILD_TAG_OPTIONS = createSelectOptions(CHILD_TAGS, false);

export function TagsSelect({
	tags,
	onTagsChanged,
	label,
	options,
	placeholder,
}) {
	return (
		<Flex>
			<FlexItem flexGrow={0} flexShrink={0} paddingRight="small">
				<Text bold as={CenteredText}>
					{label}
				</Text>
			</FlexItem>
			<FlexItem flexGrow={1} paddingRight="small">
				<MultiSelect
					action={{
						actionType: 'destructive',
						content: 'Clear Tags',
						icon: <DeleteIcon />,
						onActionClick: () => onTagsChanged([]),
					}}
					filterable={true}
					maxHeight={300}
					onOptionsChange={onTagsChanged}
					options={options}
					placeholder={placeholder}
					placement="bottom-start"
					required
					value={tags}
				/>
			</FlexItem>
		</Flex>
	);
}
